import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconCalculator: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 2.25H7C4.582 2.25 3.25 3.582 3.25 6V18C3.25 20.418 4.582 21.75 7 21.75H17C19.418 21.75 20.75 20.418 20.75 18V6C20.75 3.582 19.418 2.25 17 2.25ZM19.25 18C19.25 19.577 18.577 20.25 17 20.25H7C5.423 20.25 4.75 19.577 4.75 18V6C4.75 4.423 5.423 3.75 7 3.75H17C18.577 3.75 19.25 4.423 19.25 6V18ZM15 5.25H9C7.591 5.25 6.75 6.091 6.75 7.5V8.5C6.75 9.909 7.591 10.75 9 10.75H15C16.409 10.75 17.25 9.909 17.25 8.5V7.5C17.25 6.091 16.409 5.25 15 5.25ZM15.75 8.5C15.75 9.089 15.589 9.25 15 9.25H9C8.411 9.25 8.25 9.089 8.25 8.5V7.5C8.25 6.911 8.411 6.75 9 6.75H15C15.589 6.75 15.75 6.911 15.75 7.5V8.5ZM17 14C17 14.552 16.552 15 16 15C15.448 15 15 14.552 15 14C15 13.448 15.448 13 16 13C16.552 13 17 13.448 17 14ZM13 14C13 14.552 12.552 15 12 15C11.448 15 11 14.552 11 14C11 13.448 11.448 13 12 13C12.552 13 13 13.448 13 14ZM9 14C9 14.552 8.552 15 8 15C7.448 15 7 14.552 7 14C7 13.448 7.448 13 8 13C8.552 13 9 13.448 9 14ZM17 17C17 17.552 16.552 18 16 18C15.448 18 15 17.552 15 17C15 16.448 15.448 16 16 16C16.552 16 17 16.448 17 17ZM13 17C13 17.552 12.552 18 12 18C11.448 18 11 17.552 11 17C11 16.448 11.448 16 12 16C12.552 16 13 16.448 13 17ZM9 17C9 17.552 8.552 18 8 18C7.448 18 7 17.552 7 17C7 16.448 7.448 16 8 16C8.552 16 9 16.448 9 17Z"
      fill={color}
    />
  </svg>
);

export default IconCalculator;
